module.exports = __webpack_public_path__ + "static/media/Board_6@2x.8e0e5680.png";